import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  globalColumnSelectionOrderReport: {
    country: false,
    province: false,
    district: false,
    sub_district: false,
    urban_village: false,
    postal_code: false,
  }
}

const globalColumnSelectionOrderReportSlices = createSlice({
  name: 'globalColumnSelectionOrderReport',
  initialState,
  reducers: {
    setGlobalColumnSelectionOrderReport: (state, action) => {
      state.globalColumnSelectionOrderReport = action.payload
    }
  }
});

export const { setGlobalColumnSelectionOrderReport } = globalColumnSelectionOrderReportSlices.actions;

export default globalColumnSelectionOrderReportSlices.reducer;